import { makeStyles } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';
import { Height } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'calc(100% - 80px)',
    padding: '0 40px',
    background: 'rgba(0, 0, 0, .05)',
    position: 'absolute',
    bottom: 0,
    ['@media (max-width:600px)']: {
      padding: '0 15px',
      width: '100% !important'
    }
  },
  confirmPayment: {
    fontSize: '13px',
    marginTop: '2px',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden', 
     [theme.breakpoints.down('sm')]: {
      display: '-webkit-box',
    '-webkit-line-clamp': 7,
    }
  },
  privacy: {
    fontWeight: 'bold',
    textDecoration: 'underline',
    color: theme.baseUI.color
  },
  checkboxWrapper: {
    margin: '0 0 4px 0',
    ['@media (max-width: 850px)']: {
      position: 'absolute',
      bottom: '44px',
      left: '0',
      width: 'calc(100% - 80px)',
      padding: '5px 40px',
      display: 'flex',
      boxShadow: '0px -1px 0px #E2EBF6'
    },
    ['@media (max-width: 600px)']: {
      padding: '5px 15px',
      width: '100%',      
      backgroundColor: 'white',
      zIndex: '1',
      Height: '100%'
    }
  },
  buttonsWrapper: {
    margin: '6px 0',
    minWidth: 'fit-content'
  },
  cancelBtn: {
    fontSize: '13px',
    padding: '6px 15px',
    marginRight: '15px',
    backgroundColor: 'white',
    color: theme.baseUI.color,
    border: `1px solid ${theme.baseUI.color}`,
    '&:hover': {
      backgroundColor: 'white'
    },
    ['@media (max-width: 400px)']: {
      marginRight: '8px'
    }
  },
  totalBtn: {
    fontSize: '13px',
    padding: '6px 15px',
    backgroundColor: theme.baseUI.color,
    border: `1px solid ${theme.baseUI.color}`,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.baseUI.color,
      color: '#FFFFFF'
    }
  },
  total: {
    padding: '0 15px 0 0',
    borderRight: '1px solid white',
    textTransform: 'none',
    ['@media (max-width:600px)']: {
      display: 'none'
    }
  },
  next: {
    padding: '0 0 0 15px',
    ['@media (max-width:600px)']: {
      padding: '0 5px'
    }
  },
  stepNumber: {
    color: theme.baseUI.color,
    marginRight: '6px'
  },
  withoutTotal: {
    padding: '0 5px'
  },
  navigation: {
    display: 'none',
    ['@media (max-width:850px)']: {
      display: 'block'
    }
  }
}));

export default useStyles;
